/* eslint-disable no-duplicate-case */
import React, { useEffect, useState } from "react";
import parse from "html-react-parser";
import {
  Badge,
  Button,
  Banner,
  Modal,
  TextField,
  ChoiceList,
  Icon,
  Link,
} from "@shopify/polaris";
import "../../css/pricing-table.css";
import config from "../../config/config";
import Swal from "sweetalert2";
import { Row, Col } from "reactstrap";
import { MobileAcceptMajor } from "@shopify/polaris-icons";
import { useDispatch, useSelector } from "react-redux";
import callApi from "../../utils/apiCaller";
import saleoff from "../../assets/bestseller.png";
import flash from "../../assets/pricing/flash.png";
import pricingTableData from "./pricingTableData";
import { actFecthModalCharge } from "../../actions";

const PlanTableNew = (props) => {
  const { dataSettings, commonSetting } = useSelector((state) => state);
  const { modalCharge, planTableState } = commonSetting;
  const dispatch = useDispatch();

  const [stateData, setStateData] = useState({
    selectOptionsOverQuota: "1",
    modalStatus: false,
    rangeDayProcess: "30",
    choosePlan: "",
    chooseSubscription: "monthly",
    tabSelected: 0,
  });

  const [currentPlanLevel, setCurrentPlanLevel] = useState(0);
  const [typeSubcription, setTypeSubcription] = useState("monthly");
  const [choosePlanLevel, setChoosePlanLevel] = useState(0);

  const openModal = (plan, subscription) => {
    if (config.role !== "view") {
      if (
        config.platform === "WOO_COMMERCE" ||
        config.shop == "https://www.1001casquettes.com"
      ) {
        if (
          config.wooType == "extension" ||
          config.shop == "https://www.1001casquettes.com"
        ) {
          let params = {
            action: "activePlan",
            subscription: subscription,
            plan: plan,
          };
          callApi("get", params).then((res) => {
            if (res.data.state === 1) {
              window.top.location.replace(res.data.confirmation_url);
            } else if (res.data.state === 3) {
              window.location.reload();
            } else if (res.data.state === 4) {
              Swal.fire({
                icon: "success",
                title: "Successfully",
                text: res.data.msg,
                showCloseButton: false,
                showConfirmButton: true,
              }).then((result) => {
                if (result.value) {
                  window.location.reload();
                }
              });
            }
          });
        } else {
          let paymentUrl =
            config.rootLink +
            "payment/?shop=" +
            config.shop +
            "&plan=" +
            plan +
            "&subs_type=" +
            typeSubcription +
            "&website_url=" +
            config.websiteUrl;
          window.open(paymentUrl, "_blank");
        }
      } else {
        if (props.type !== "step") {
          switch (plan) {
            case "free":
              setChoosePlanLevel(1);
              break;
            case "basic":
              setChoosePlanLevel(2);
              break;
            case "pro":
              setChoosePlanLevel(3);
              break;
            case "pro_plus":
              setChoosePlanLevel(4);
              break;
            case "unlimited":
              setChoosePlanLevel(5);
              break;
            default:
              setChoosePlanLevel(1);
          }
          setStateData({
            ...stateData,
            modalStatus: true,
            choosePlan: plan,
            chooseSubscription: subscription,
          });
        } else {
          setStateData({
            ...stateData,
            modalStatus: false,
            choosePlan: plan,
            chooseSubscription: subscription,
          });

          let params = {
            action: "activePlan",
            type: plan,
            subscription: subscription,
            dayProcess: 0,
          };
          callApi("get", params).then((res) => {
            if (res.data.state === 2) {
              Swal.fire({
                icon: "success",
                title: "Successfully",
                text: res.data.msg,
                showCloseButton: false,
                showConfirmButton: false,
                timer: 3000,
              }).then((result) => {
                window.location.reload();
              });
            } else {
              window.top.location.replace(res.data.confirmation_url);
            }
          });
        }
      }
    }
  };

  const closeModal = () => {
    setStateData({
      ...stateData,
      modalStatus: false,
    });
    dispatch(actFecthModalCharge(false));
  };

  const handleChangeOptionsOverQuota = (value) => {
    setStateData({
      ...stateData,
      selectOptionsOverQuota: value,
    });
  };

  const handleChangeRangeDayProcess = (value) => {
    if (value > 60 && dataSettings.read_all_orders === "0") {
      value = 60;
    }
    setStateData({
      ...stateData,
      rangeDayProcess: value,
    });
  };

  const confirmActivePlan = () => {
    let paramsClick = {
      action: "clickReview",
      type: "click_upgrade",
      note: "table_account",
    };
    callApi("get", paramsClick);

    activePlan(stateData.choosePlan);
  };

  const activePlan = async (value) => {
    if (config.checkLocalStorage) {
      localStorage.setItem(config.shop + "-synctrack-plan", dataSettings.plan);
    }
    var dayProcess = stateData.rangeDayProcess;
    if (stateData.selectOptionsOverQuota[0] === "2") {
      dayProcess = 0;
    }
    let params = {
      action: "activePlan",
      type: value,
      subscription: stateData.chooseSubscription,
      dayProcess: dayProcess,
    };
    callApi("get", params).then((res) => {
      setStateData({
        ...stateData,
        modalStatus: false,
      });
      if (res.data.state === 2) {
        Swal.fire({
          icon: "success",
          title: "Successfully",
          text: res.data.msg,
          showCloseButton: false,
          showConfirmButton: false,
          timer: 3000,
        }).then((result) => {
          window.top.location.reload();
        });
      } else {
        window.top.location.replace(res.data.confirmation_url);
      }
    });
  };

  const handleTabChange = (value) => {
    setStateData({
      ...stateData,
      tabSelected: value,
    });
  };

  const modalDowngradeMarkup = (
    <Modal
      open={stateData.modalStatus}
      onClose={closeModal}
      title="Are you sure?"
      primaryAction={{
        content: "Confirm, I understand the risk",
        onAction: confirmActivePlan,
      }}
      secondaryActions={[
        {
          content: "Leave it now",
          onAction: closeModal,
        },
      ]}
    >
      <Modal.Section>
        <div className="plan-table">
          Please confirm this downgrade plan may affect immediately to{" "}
          <b>the number of orders tracking syncing to Paypal</b>. And you need
          to <b>reconnect the sub-stores</b> if you are using{" "}
          <b>Multi-stores integration</b>
        </div>
      </Modal.Section>
    </Modal>
  );

  const modalUpgradeMarkup = (
    <Modal
      open={stateData.modalStatus}
      onClose={closeModal}
      title="Would you like to process the old orders? "
      primaryAction={{
        content: "Active Plan",
        onAction: confirmActivePlan,
      }}
      secondaryActions={[
        {
          content: "Cancel",
          onAction: closeModal,
        },
      ]}
    >
      <Modal.Section>
        <div className="plan-table">
          <ChoiceList
            choices={[
              {
                label: (
                  <div
                    className="d-flex plan-table"
                    style={{ lineHeight: "36px" }}
                  >
                    Process the old orders in last{" "}
                    <div className="ml-2 mr-2">
                      <TextField
                        type="number"
                        value={stateData.rangeDayProcess}
                        onChange={handleChangeRangeDayProcess}
                        max={dataSettings.read_all_orders === "0" ? 60 : 365}
                      />
                    </div>
                    days (max 365 days)
                  </div>
                ),
                value: "1",
              },
              { label: "Skip the old orders", value: "2" },
            ]}
            selected={stateData.selectOptionsOverQuota}
            onChange={handleChangeOptionsOverQuota}
          />
        </div>
        <div className="mt-3">
          <Banner title="Note">
            <p>
              - The old orders will be count to your number of usage this month.
              <br />- If you are using multi-store integration, the subscription
              fee will apply to your main store.
            </p>
          </Banner>
        </div>
      </Modal.Section>
    </Modal>
  );

  useEffect(() => {
    switch (dataSettings.plan) {
      case "free":
        setCurrentPlanLevel(1);
        break;
      case "basic":
        setCurrentPlanLevel(2);
        break;
      case "pro":
        setCurrentPlanLevel(3);
        break;
      case "pro_plus":
        setCurrentPlanLevel(4);
        break;
      case "unlimited":
        setCurrentPlanLevel(5);
        break;
      default:
        setCurrentPlanLevel(1);
    }
  }, [dataSettings]);
  return (
    <div>
      <Row>
        <div className="text-center w-100 mt-4">
          <div className="pricing-button-group">
            <button
              onClick={() => setTypeSubcription("monthly")}
              className={
                typeSubcription == "monthly"
                  ? "pricing-pkg-btn  activePkg"
                  : "pricing-pkg-btn "
              }
            >
              {" "}
              Monthly{" "}
            </button>
            <button
              onClick={() => setTypeSubcription("annually")}
              className={
                typeSubcription == "annually"
                  ? "pricing-pkg-btn  activePkg"
                  : "pricing-pkg-btn "
              }
            >
              Yearly <span className="pricing__discount">Save 30%</span>
            </button>
          </div>
        </div>
      </Row>
      <div className="new-plan-table">
        {pricingTableData.general.map((plan, index) => {
          return (
            <div key={index} className={"new-plan-table-layout " + plan.name}>
              {plan.name === "pro" ? (
                <img className="best-seller" src={saleoff} alt="best seller" />
              ) : null}
              {/* {typeSubcription == "annually" &&
							(plan.name === "pro_plus" ||
								plan.name === "unlimited") ? (
								<img
									className="best-seller"
									src={flash}
									alt="best seller"
								/>
							) : null} */}
              <div className="new-plan-table-layout-img">
                <div className="price_info">
                  <p className="h6 pricing-title">{plan.display_name}</p>
                  <small className="text-secondary">{plan.description}</small>
                  <p className="h3 pricing-plan">
                    {typeSubcription == "monthly"
                      ? plan.price
                      : plan.priceYearly}
                  </p>
                  {typeSubcription == "annually" ? (
                    <p className="h3 pricing-plan-strike">{plan.price}</p>
                  ) : null}
                  <small className="text-secondary">
                    {typeSubcription == "monthly" ? "monthly" : "per month"}{" "}
                  </small>
                </div>
              </div>
              {pricingTableData.content.map((content, key) => {
                return (
                  <div
                    key={key}
                    className="new-plan-table-layout-content text-center d-flex"
                  >
                    {content.count[index] !== "" ? (
                      <Icon color="success" source={MobileAcceptMajor} />
                    ) : null}
                    {parse(content.count[index])}
                  </div>
                );
              })}

              {/* {config.platform !== "WOO_COMMERCE"
							? annuallyMarkup(plan)
							: null} */}

              {typeSubcription == "monthly" ? (
                <div className="new-plan-table-layout-content">
                  {dataSettings.subscription === "monthly" &&
                  dataSettings.plan === plan.name ? (
                    <div
                      style={{ pointerEvents: "none" }}
                      className="text-center "
                    >
                      <Badge status="success" progress="complete">
                        Activated
                      </Badge>
                    </div>
                  ) : (
                    <div className="text-center">
                      <Button
                        primary
                        onClick={() => openModal(plan.name, "monthly")}
                      >
                        Choose plan
                      </Button>
                    </div>
                  )}
                </div>
              ) : (
                <div className="new-plan-table-layout-content">
                  {dataSettings.subscription === "annually" &&
                  dataSettings.plan === plan.name ? (
                    <div
                      style={{ pointerEvents: "none" }}
                      className="text-center "
                    >
                      <Badge status="success" progress="complete">
                        Activated
                      </Badge>
                    </div>
                  ) : (
                    <div className="text-center">
                      <Button
                        primary
                        onClick={() => openModal(plan.name, "annually")}
                      >
                        Choose plan
                      </Button>
                    </div>
                  )}
                </div>
              )}
            </div>
          );
        })}
        {currentPlanLevel > choosePlanLevel
          ? modalDowngradeMarkup
          : modalUpgradeMarkup}
        {/* {modalDowngradeMarkup}
      {modalUpgradeMarkup} */}
      </div>
    </div>
  );
};

export default PlanTableNew;
